export default {
  'app.setting.pagestyle': 'Page style setting',
  'app.setting.pagestyle.light': 'Light style',
  'app.setting.pagestyle.dark': 'Dark style',
  'app.setting.pagestyle.realdark': 'RealDark style',
  'app.setting.themecolor': 'Theme Color',
  'app.setting.navigationmode': 'Navigation Mode',
  'app.setting.content-width': 'Content Width',
  'app.setting.fixedheader': 'Fixed Header',
  'app.setting.fixedsidebar': 'Fixed Sidebar',
  'app.setting.multitab': 'View Multitab',
  'app.setting.sidemenu': 'Side Menu Layout',
  'app.setting.topmenu': 'Top Menu Layout',
  'app.setting.content-width.fixed': 'Fixed',
  'app.setting.content-width.fluid': 'Fluid',
  'app.setting.othersettings': 'Other Settings',
  'app.setting.weakmode': 'Weak Mode',
  'app.setting.copy': 'Copy Setting',
  'app.setting.loading': 'Loading theme',
  'app.setting.copyinfo': 'Copy success，please replace defaultSettings in src/config/defaultSettings.js',
  'app.setting.production.hint': 'Setting panel shows in development environment only, please manually modify',
  'app.setting.themecolor.daybreak': 'Daybreak Blue',
  'app.setting.themecolor.dust': 'Dust Red',
  'app.setting.themecolor.volcano': 'Volcano',
  'app.setting.themecolor.sunset': 'Sunset Orange',
  'app.setting.themecolor.cyan': 'Cyan',
  'app.setting.themecolor.green': 'Polar Green',
  'app.setting.themecolor.geekblue': 'Geek Blue',
  'app.setting.themecolor.purple': 'Golden Purple',

  '开始时间': 'Start time',
  '结束时间': 'End time',
  '全部': 'All',
  '新增': 'Add',
  '确定': 'Determine',
  '审核': 'Audit',
  '修改': 'Edit',
  '复制': 'Copy',
  '删除': 'Remove',
  '添加下级': 'Add child',
  '关闭': 'Close',
  '导出': 'Export',
  '选中导出': 'Select export',
  '导入': 'Import',
  '查询': 'Query',
  '重置': 'Reset',
  '详情': 'Info',
  '上传': 'Upload',
  '展开': 'Expand',
  '收起': 'Stow',
  '更多': 'More',
  '保存': 'Save',
  '取消': 'Cancel',
  '翻译': 'Translation',
  '刷新缓存': 'Flush cache',
  '请输入': 'Please enter ',
  '请选择': 'Please select ',
  '清除': 'Clear',
  '是': 'Yes',
  '否': 'No',
  '启用': 'Enable',
  '禁用': 'Disable',
  '操作': 'Operation',
  '添加': 'Add',
  '创建时间': 'Create time',
  '排序': 'Sort',
  '服务费': 'Service Amount',
  '所属组织': 'Dept name',
  '确认删除所选中数据': 'Confirm deletion of selected data?',
  '删除成功': 'Remove success',
  '确认取消': 'Confirm cancel?',
  '取消成功': 'Cancel success',
  '新增成功': 'Add success',
  '修改成功': 'Edit success',
  '上传成功': 'Upload success',
  '共': 'Total ',
  '条': ' Record',
  '默认': 'Default',
  '中等': 'Medium',
  '紧凑': 'Compact',
  '多语言配置': 'Multi-Language configuration',
  '列展示排序': 'Column display/sort',
  '列排序需拖动名称': 'Column sorting requires dragging name',
  '不能为空': ' Not be empty',
  '不能小于0': 'Not be zero',
  '语言': 'Language',
  '根节点': 'Root',
  '父级': 'Parent',
  '创建开始时间': 'Create start time',
  '创建结束时间': 'Create end time',
  '是否确认导出': 'Confirm Export?',
  '此操作将导出当前条件下所有数据而非选中数据': 'This will export all data under the current condition instead of the selected data',
  '此操作将导出选中数据': 'This will export the selected data',
  '位置': 'Position',
  '跳转类型': 'Jump type',
  '广告名称': 'Name',
  '选择申请': 'Select apply',
  '外链': 'Outlink',
  '内容详情': 'Info',
  '是否热门': 'Is Hot',
  '是否隐藏': 'Is hidden',
  '展示时长': 'Show times',
  '展示次数': 'Show num',
  '点击次数': 'Click num',
  '跳转次数': 'Jump num',
  '封面图': 'Cover img',
  '详情图': 'Detail img',
  '联行号':'Branch code',
  '银行全名':'Bank name',
  '银行简称':'Bank alias',
  '银行名称':'Branch name',
  '清算行号':'Clearing code',
  '银行编码':'Bank code',
  '银行图标':'Bank icon',
  '是否常用':'Is common',
  '银行卡号':'Bank card no',
  '银行支行':'Bank full name',
  '结算账户名':'Account name',

  '图标':'Icon',
  '城市名称':'City name',
  '省份名称':'Province name',
  '备注':'Remark',
  '店铺入驻时长':'Store Entry Duration',
  '用户ID': 'UserId',
  '回答列表': 'Answer List',
  '发送消息': 'Send message',
  '手机号': 'Mobile',
  '获得数':'Acquired num',
  '赠送数':'Gift num',
  '联系方式': 'Contact Information',
  '用户等级': 'Level',
  '邮箱': 'Email',
  '昵称': 'Nickname',
  '微信': 'Weixin',
  '积分': 'Score',
  '真实姓名': 'RealName',
  '身份证': 'Idcard',
  '头像': 'Avatar',
  '性别': 'Sex',
  '生日': 'Birthday',
  '邀请码': 'Invite code',
  '注册时间': 'Register time',
  '用户状态': 'User status',
  '注销原因': 'Cancel reason',
  '审核状态': 'Audit status',
  '审核失败原因': 'Audit fail reason',
  '审核人': 'Audit ',
  '审核时间': 'Audit tim',
  '注销时间': 'Cancel time',
  '会员等级名称': 'Level name',
  '等级图片': 'Level picture',
  '等级图标': 'Level icon',
  '会员等级排序': 'Sort',
  '升级所需值': 'Score',
  '用户': 'User',
  '处理状态': 'Processing Status',
  '投诉原因': 'Reason for Complaint',
  '处理': 'Process',
  '反馈图片': 'Feedback Image',
  '是否审核通过':'Is pass',
  '反馈类型': 'Feedback Type',
  '反馈内容': 'Feedback Content',
  '处理结果': 'Processing Result',
  '编号': 'No',
  '公司名称': 'Company Name',
  '公司编码': 'Company Code',
  '公司类型': 'Company Type',
  '公司logo': 'Company Logo',
  '是否选用': 'Whether Selected',
  '交易单号': 'Transaction Number',
  '子订单': 'Sub-order',
  '订单编号': 'Order Number',
  '订单类型': 'Order Type',
  'ip': 'IP',
  '支付方式': 'Payment Method',
  '交易类型': 'Transaction Type',
  '支付金额': 'Payment Amount',
  '账期金额': 'Credit Period Amount',
  '手续费': 'Handling Fee',
  '支付信息': 'Payment Information',
  '三方订单号': 'Third-party Order Number',
  '三方支付流水号': 'Third-party Payment Transaction Number',
  '支付状态': 'Payment Status',
  '交易完成时间': 'Transaction Completion Time',
  '过期时间': 'Expiration Time',
  '常见问题标题': 'FAQ Title',
  '常见问题简述': 'FAQ Summary',
  '问题分类': 'Problem Category',
  '常见问题内容': 'FAQ Content',
  '显示顺序': 'Display Order',
  '状态': 'Status',
  '创建人': 'Creator',
  '修改人': 'Modifier',
  '修改时间': 'Modification Time',
  '版本号': 'Version Number',
  '主图': 'Main Image',
  '标题': 'Title',
  '视频缩略图': 'Thumbnail',
  '副标题': 'Sub Title',
  '内容': 'Content',
  '回答': 'Answer',
  '关注数量': 'Star num',
  '选择商品' :'select Goods',
  'APP类型': 'APP Type',
  '更新说明': 'Update Description',
  '更新包大小': 'Update Package Size',
  '更新地址类型: 0内部 1其它(应用市场)': 'Update Address Type: 0 Internal 1 Other (App Market)',
  '其它(应用市场)应用 【内部使用文件库】': 'Other (App Market) App [Internal File Library]',
  '版本号名称': 'Version Name',
  '更新类型': 'Update Type',
  '强制升级': 'Force Upgrade',
  '计划更新时间: 0及时更新 1计划更新': 'Scheduled Update Time: 0 Immediate Update 1 Scheduled Update',
  '计划更新时间': 'Scheduled Update Time',
  '下载地址': 'Download Address',
  '上传时间': 'Upload Time',
  '更新时间': 'Update Time',
  '名称': 'Name',
  '类型': 'Type',
  '是否显示': 'Whether Displayed',
  '搜索内容': 'Search Content',
  '搜索次数': 'Search Count',
  '发货方式': 'Shipping Method',
  '发货人手机号': 'Shipper Phone Number',
  '发货时间': 'Shipping Time',
  '发货记录编号': 'Shipping Record Number',
  '发货开始时间': 'Shipping Start Time',
  '发货结束时间': 'Shipping End Time',
  '商家入驻时长': 'Entry Time',
  '全部订单': 'All Orders',
  '此操作将导出当所有待发货订单而非选中数据': 'This operation will export all pending shipping orders, not the selected data',
  '导出待发货': 'Export Pending Shipping',
  '导入发货单': 'Import Shipping List',
  '接单': 'Accept Order',
  '接单成功': 'Order Accepted Successfully',
  '物流公司': 'Logistics Company',
  '物流单号': 'Logistics Number',
  '物流详情': 'Logistics Details',
  '寄件人手机号': 'Sender Phone Number',
  '订单来源': 'Order Source',
  '下单数量': 'Order Quantity',
  '订单信息': 'Order Information',
  '订单详情': 'Order Details',
  '买家ID': 'Buyer ID',
  '买家名称': 'Buyer Name',
  '买家信息': 'Buyer Information',
  '手机号或邮箱': 'Phone Number or Email',
  '订单状态': 'Order Status',
  '下单时间': 'Order Placement Time',
  '下单开始时间': 'Order Placement Start Time',
  '下单结束时间': 'Order Placement End Time',
  '支付时间': 'Payment Time',
  '退款状态': 'Refund Status',
  '商品数量': 'Product Quantity',
  '商品金额': 'Product Amount',
  '商品实付金额': 'Actual Payment Amount for Product',
  '优惠金额': 'Discount Amount',

  '订单金额': 'Order Amount',
  '运费金额': 'Shipping Fee',
  '运费实付': 'Actual Shipping Fee',
  '用户备注': 'User Remarks',
  '商品信息': 'Product Information',
  '观演人列表': 'Play user',
  '门票信息': 'Ticket info',
  '活动信息': 'Activity Information',
  '收货地址信息': 'Shipping Address Information',
  '实付单价': 'Actual Unit Price',
  '数量': 'Quantity',
  '收货人姓名': 'Recipient Name',
  '车辆信息': 'Car Name',
  '地址类型': 'Address Type',
  '地区': 'Region',
  '经度': 'Longitude',
  '纬度': 'Latitude',
  '详细地址': 'Detailed Address',
  '订单发货': 'Ship',
  '发货成功': 'Shipping Successful',
  '取消订单': 'Cancel Order',
  '订单改价': 'Amount Change',
  '锁单时间': 'Order Lock Time',

  '发货备注': 'Shipping Remarks',

  '订单原价': 'Original Order Price',
  '实付金额': 'Actual Payment Amount',
  '运费': 'Shipping Fee',
  '是否首单': 'Whether First Order',
  '是否催发货': 'Whether Urge Shipping',
  '应募信息': 'Application Information',
  '是否异常单': 'Whether Abnormal Order',
  '异常单开始时间': 'Abnormal Order Start Time',
  '异常单结束时间': 'Abnormal Order End Time',
  '原订单编号': 'Original Order Number',
  '售后单编号': 'After-sales Order Number',
  '售后类型': 'After-sales Type',
  '售后状态': 'After-sales Status',
  '售后凭证': 'After-sales Evidence',
  '购买数量': 'Purchase Quantity',
  '售后数量': 'After-sales Quantity',
  '申请开始时间': 'Application Start Time',
  '申请结束时间': 'Application End Time',
  '退款金额': 'Refund Amount',
  '申请时间': 'Application Time',
  '售后原因': 'After-sales Reason',
  '售后信息': 'After-sales Information',
  '原订单信息': 'Original Order Information',
  '售后详情': 'After-sales Details',
  '售后商品': 'After-sales Product',
  '是否同意': 'Whether Agree',
  '拒绝原因': 'Rejection Reason',
  '审核成功': 'Review Successful',
  '退款': 'Refund',
  '是否确认退款': 'Whether Confirm Refund',
  '退款成功': 'Refund Successful',
  '变动的积分数': 'Changed Points',
  '变动前剩余积分': 'Remaining Points Before Change',
  '变动后剩余积分': 'Remaining Points After Change',
  '成就名称': 'Achievement Name',
  '成就图标': 'Achievement Icon',
  '成就图片': 'Achievement Image',
  '成就图片(暗)': 'Achievement Image (Dark)',
  '成就类型': 'Achievement Type',
  '成就条件': 'Achievement Condition',
  'ID': 'ID',
  '商品id': 'Product ID',
  '公式内容': 'Formula Content',
  '公式名称': 'Formula Name',
  '是否使用': 'Whether Used',
  '应用范围': 'Application Scope',
  '创建者': 'Creator',
  '品牌名称': 'Brand Name',
  '品牌备注': 'Brand Remarks',
  '品牌首字母': 'Brand Initial',
  'logo': 'Logo',
  '主键': 'Primary Key',
  '车辆名称': 'Vehicle Name',
  '最大容积': 'Maximum Volume',
  '最大承重': 'Maximum Load Capacity',
  '起步价': 'Base Fare',
  '起步公里数': 'Base Kilometers',
  '每公里单价': 'Unit Price per Kilometer',
  '逻辑删除标记': 'Logical Deletion Mark',
  'id': 'Id',
  '发货地id': 'Shipping Origin ID',
  '发货地': 'Shipping Origin',
  '目的地id': 'Destination ID',
  '目的地': 'Destination',
  '距离 km': 'Distance (km)',
  '模板名称': 'Template Name',
  '计费方式': 'Billing Method',
  '物流类型': 'Logistics type',
  '发货区域': 'Shipping Area',
  '分类名称': 'Category Name',
  '分类图片': 'Category Image',
  '上级分类': 'Parent Category',
  '分类等级': 'Category Level',
  '关键词': 'Keyword',
  '是否首页展示': 'Whether Displayed on Homepage',
  '是否参与筛选': 'Whether Participates in Filtering',
  '查看关联商品': 'View Related Products',
  '标签': 'Tag',
  '预览': 'Preview',
  '复制链接': 'Copy Link',
  '售卖区域': 'Sales Area',
  '批量上架': 'Batch List',
  '批量下架': 'Batch Unlist',
  '批量审核': 'Batch Audit',
  '批量复制': 'Batch Copy',
  '确认复制': 'Confirm Copy?',
  '复制成功': 'Copy Successful',
  '选择明星': 'Select Celebrity',
  '选择俱乐部': 'Select Club',
  '选择运费模板': 'Select Shipping Template',
  '基础信息': 'Basic Information',
  '标签信息': 'Tag Information',
  '规格信息': 'Spec Information',
  '详情信息': 'Detail Information',
  '上架成功': 'List Successful',
  '下架成功': 'Unlist Successful',
  '确认上架': 'Confirm List?',
  '确认下架': 'Confirm Unlist?',
  '添加规格': 'Add Spec',
  '修改规格': 'Modify Spec',
  '商品类型': 'Product Type',
  '商品': 'Product',
  '文章': 'News',
  '是否有海报筒': 'Whether Has Poster Tube',
  '明星': 'Celebrity',
  '购买人数': 'Number of Buyers',
  '已售数量': 'Number Sold',
  '实时未付款数量': 'Real-time Unpaid Quantity',
  '限购数': 'Purchase Limit',
  '售卖开始时间': 'Sales Start Time',
  '售卖结束时间': 'Sales End Time',
  '售卖结束日期': 'Sales End Date',
  '上架时间': 'Listing Time',
  '是否多规格': 'Whether Multiple Specs',
  '是否允许合并购买': 'Whether Allow Combined Purchase',
  '商品颜色': 'Product Color',
  '商品详情': 'Product Details',
  '市场价': 'Market Price',
  '商品售价': 'Product Selling Price',
  '划线价': 'Crossed Price',
  '成本价': 'Cost Price',
  '虚拟销量': 'Virtual Sales Volume',
  '是否展示销量': 'Whether Display Sales Volume',
  '商品价': 'Product Price',
  '公式配置': 'Formula Config',
  '属性配置': 'Property Config',
  '商家': 'Merchant',
  '商家名称': 'Merchant Name',
  '商家logo': 'Merchant Logo',
  '商家背景图': 'Background',
  '详细地区': 'Area',
  '商家所在地': 'Merchant Location',
  '商家状态': 'Merchant Status',
  '商家类型': 'Merchant Type',
  '所属商家': 'Merchant',
  '经营类型': 'Business Type',
  '经营类型提示': 'Mall or same-city delivery',
  '主营行业': 'Main Industry',
  '主营行业id': 'Main industry ID',
  '客服电话': 'Customer Service Phone',
  '子商户': 'Sub-merchant',
  '二维码': 'QR Code',
  '结算': 'Settlement',
  '保证金': 'Margin',
  '余额': 'Balance',
  '入驻时长': 'Entry Duration',
  '申请类型': 'Application Type',
  '联系人姓名': 'Contact Name',
  '联系人电话': 'Contact Phone',
  '联系人邮箱': 'Contact Email',
  '身份证号': 'ID Card No',
  '保证金审核': 'Margin Audit',
  '续费审核': 'Renewal Audit',
  '持卡人姓名': 'Cardholder Name',
  '开户行名称': 'Bank Branch Name',
  '开户行联行号': 'Bank Branch Code',
  '是否默认': 'Whether Default',
  '收货人': 'Recipient',
  '省份': 'Province',
  '城市': 'City',
  '县': 'County',
  '变动类型': 'Change Type',
  '余额类型': 'Balance Type',
  '变化金额': 'Change Amount',
  '操作前金额': 'Amount Before',
  '操作后金额': 'Amount After',
  '账单标题': 'Bill Title',
  '用户实付': 'User Payment',
  '结算金额': 'Settle amount',
  '平台优惠补贴': 'Platform Subsidy',
  '平台抽成点': 'Platform Commission Rate',
  '预计恢复时间': 'Expected Recovery Time',
  '支行名称': 'Branch Name',
  '结算账户': 'Settlement Account',
  '结算账户名称': 'Settlement Account Name',
  '提现': 'Withdrawal',
  '打款凭证': 'Payment Voucher',
  '商户类型': 'Merchant Type',
  '类目名称': 'Category Name',
  '类目图片': 'Category Image',
  '年费': 'Annual Fee',
  '支付宝mcc': 'Alipay MCC',
  '微信mcc': 'WeChat MCC',
  '银联mcc': 'UnionPay MCC',
  '商户注册名称': 'Merchant Registration Name',
  '进件状态': 'Application Status',
  '审核理由': 'Audit Reason',
  '分账状态': 'Split Status',
  '内部商户号': 'Internal Merchant No',
  '银联商户号': 'UnionPay Merchant No',
  '营业执照名称': 'Business License Name',
  '营业执照编号': 'Business License No',
  '法人姓名': 'Legal Person Name',
  '法人身份证号码': 'Legal Person ID Card',
  '商户联系人手机': 'Merchant Contact Phone',
  '商户联系人': 'Merchant Contact',
  '结算账户开户行名称': 'Settlement Bank Name',
  '结算账户账号': 'Settlement Account No',
  '修改进件信息': 'Edit Application Info',
  '上架': 'List',
  '下架': 'Unlist',

  '申请状态': 'Application Status',
  '身份证人像面': 'ID card (portrait side)',
  '法人名称': 'Legal Person Name',
  '法人身份证号': 'Legal Person ID No.',
  '法人手机号': 'Legal Person Mobile',
  '联系人名称': 'Contact Name',
  '账户类型': 'Account Type',
  '开户银行名称': 'Bank Name',
  '开户银行地址': 'Bank Address',
  '结算账号': 'Settlement Account No.',
  '开户支行': 'Opening Branch',
  '商家账户.开户支行': 'Select opening branch',
  '年': ' years',

  '优惠券编号': 'Coupon ID',
  '优惠券名称': 'Coupon Name',
  '优惠券类型': 'Coupon Type',
  '优惠券状态': 'Coupon Status',
  '获取方式': 'Acquisition Method',
  '使用条件': 'Usage Condition',
  '减免金额': 'Discount Amount',
  '手动发券': 'Manual Send Coupon',
  '上架状态': 'Listing Status',
  '领取开始时间': 'Receive Start Time',
  '领取结束时间': 'Receive End Time',
  '使用开始时间': 'Use Start Time',
  '使用结束时间': 'Use End Time',
  '用户手机号': 'User Phone',
  '使用数量': 'Used Quantity',
  '领券时间': 'Receive Time',
  '三方交易单号': 'Third-party Transaction No',
  '抵扣金额': 'Deduction Amount',
  '使用状态': 'Usage Status',
  '使用时间': 'Usage Time',
  '类型名称': 'Type Name',
  '群组id': 'Group ID',
  '视频标题': 'Video Title',
  '直播间名称': 'Live Room Name',
  '直播用户昵称': 'Live User Nickname',
  '直播分类': 'Live Category',
  '直播封面': 'Live Cover',
  '预计开播时间': 'Expected Start Time',
  '直播关闭时间': 'Live End Time',
  '直播状态': 'Live Status',
  '话题名称': 'Topic Name',
  '话题图片': 'Topic Image',
  '热度': 'Popularity',
  '礼物名称': 'Gift Name',
  '礼物价格': 'Gift Price',
  '特效': 'Effect',
  '发送者手机号': 'Sender Phone',
  '发送者昵称': 'Sender Nickname',
  '接收者手机号': 'Receiver Phone',
  '接收者昵称': 'Receiver Nickname',
  '直播间': 'Live Room',
  '赠送数量': 'Gift Count',
  '赠送时间': 'Gift Time',
  '商品编号': 'Product Number',
  '用户编号': 'User Id',
  '单号': 'Id',
  '规格名称': 'Spec Name',
  '规格描述': 'Spec Desc',
  '商品名称': 'Product Name',
  '商品重量': 'Product Weight',
  '商品体积': 'Product Volume',
  '包装单位': 'Packaging Unit',
  '单位商品数量': 'Quantity per Unit Product',
  '商品主图': 'Main Product Image',
  '商品视频': 'Video',
  '商品轮播图': 'Product Carousel Image',
  '商品示例图': 'Product Example Image',
  '商品分类': 'Product Category',
  '平台商品分类': 'Plat Product Category',
  '商家商品分类': 'Merchant Product Category',
  '商品关键词': 'Product Keywords',
  '最大商品数': 'Max goods',
  '预计发货时间': 'Delivery time',
  '快递模板': 'Express Template',
  '发票税点配置': 'Tax Point',
  '购买数量折扣': 'Purchase Quantity Discount',
  '发货时间折扣': ' Shipping time Discount',
  '是否自动上架': ' Is Auto OnSale',
  "温馨提示":"Tips",
  '费率': 'Rate',
  '品牌': 'Brand',
  '运费模板': 'Shipping Template',
  '商品价格': 'Product Price',
  '活动价格': 'Activity Price',
  '秒杀价格': 'Flash Sale Price',
  '团购价格': 'Group Buying Price',
  '会员价格': 'Member Price',
  '限购数量': 'Purchase Limit Quantity',
  '商品库存': 'Product Inventory',
  '预警库存': 'Inventory Warning Level',
  '商品状态': 'Product Status',
  '实际销量': 'Actual Sales Volume',
  '售卖范围': 'Sales Scope',
  '是否推荐': 'Whether Recommended',
  '是否新品': 'Whether New Product',
  '是否展示': 'Whether to show',
  '是否置顶': 'Whether to pin',
  '是否匿名评价': 'Whether anonymous review',
  '评价内容': 'Review Content',
  '评价图片': 'Review Images',
  '评价人名称': 'Reviewer Name',
  '评价星级': 'Review Rating',
  '评价等级': 'Review Level',
  '是否样品': 'Whether Sample',
  '是否日历展示': 'Whether Display on Calendar',
  '是否下单即锁单': 'Whether Lock Order Upon Placement',
  '是否精品': 'Whether High-quality Product',
  '是否免费领': 'Whether Free to Claim',
  '是否限购': 'Whether Purchase Limit',
  '是否爆款': 'Whether Popular Product',
  '售后方式': 'After-sales Method',
  '退款申请时间': 'Refund Application Time',
  '添加规格值': 'Add Spec Value',
  '规格值': 'Spec Value',
  '编码': 'Code',
  '价格': 'Price',
  '预览金额': 'Preview',
  '库存': 'Inventory',
  '销量': 'Sale Num',
  '原始库存': 'Original Inventory',
  '增加/减少库存': 'Increase/Decrease Inventory',
  '重量': 'Weight',
  '体积': 'Volume',
  '图片': 'Image',
  '属性名称': 'Attribute Name',
  '配置类型': 'Configuration Type',
  '输入类型': 'Input Type',
  '单价': 'Unit Price',
  '属性单位': 'Attribute Unit',
  '提示': 'Prompt',
  '是否默认选择': 'Whether Default Selected',
  '是否必选': 'Whether Required',
  '示例图': 'Example Image',
  '内容类型': 'Content Type',
  '头条分类': 'News Type',
  '门票编号': 'Ticket no',
  '区域编号': 'Area',
  '票档编号': 'No',
  '票档名称': 'Name',
  '座位数': 'Seats num',
  '区域名称': 'AreaName',
  '原库存': 'Stock',
  '座位图': 'Seat map',
  '开场时间': 'Open time',
  '散场时间': 'Close time',
  '区域地址': 'Area',
  '介绍': 'Goods introduction',
  '阵容': 'Lineup',
  '添加区域': 'Add zone',
  '描述':'Intro',
  '话题':'Topic ',
  '播放次数':'Ply num',
  '点赞次数':'Star num',
  '分享次数':'Share num',
  '被评论数量':'Reply num',
  '评论列表':'Reply list',
  '转账金额':'转账金额',
  '接收时间':'接收时间',
  '失效时间':'失效时间',
  '退款规则': 'Refund Rules',
  '投诉用户': 'Complaint users',
  '投诉用户名称': 'Complaint User Name',
  '投诉类型': 'Complaint Type',
  '使用范围':'Use Scope',
  '活动类型':'Activity Type',
  '活动标题':'Activity Title',
  '活动封面图':'Cover Img',
  '分享海报图':'Share Img',
  '分享文案':'Share',
  '适用商品类型':'Applicable Product Type',
  '减免类型':'Discount Type',
  '限制会员等级':'Limit Member',
  '是否限量':'Is Limit',
  '用户参与上限':'Limit Num',

  // order 模块
  '催发货': 'Urge Shipping',
  '期望发货时间': 'Expected Delivery Time',
  '是否确认收货': 'Confirm receipt?',
  '是否确认进入生产': 'Confirm into production?',
  '是否确认生产完成': 'Confirm production complete?',
  '发货数据导入': 'Import Delivery Data',
  '发货模板': 'Delivery Template',
  '请输入商品关键词,多个关键词之间用英文逗号分隔': 'Enter product keywords, separated by commas',

  // invoice 模块
  '抬头类型': 'Title Type',
  '发票类型': 'Invoice Type',
  '申请人': 'Applicant',
  '抬头名称': 'Title Name',
  '开票金额': 'Invoice Amount',
  '开票状态': 'Invoice Status',
  '开票图片': 'Invoice Image',
  '发票图片': 'Invoice Image',
  '税号': 'Tax ID',
  '开票': 'Issue Invoice',
  '用户名称': 'User Name',
  '公司税号': 'Company Tax ID',
  '电子邮箱': 'Email',
  '用户昵称': 'User Nickname',
  '注册地址': 'Registered Address',
  '注册电话': 'Registered Phone',
  '开户银行': 'Bank Name',
  '银行账号': 'Bank Account No',

  // merchant 模块
  '商户经营名称': 'Business name',
  '商户地区': 'Merchant region',
  '商户联系人邮箱': 'Contact email',
  '商户详细地址': 'Detail address',
  '进件ID': 'Application ID',
  '结算账户开户行号': 'Opening bank code',
  '结算人身份证国徽面': 'Settler ID (national emblem)',
  '结算人身份证人像面': 'Settler ID (portrait)',
  '结算周期': 'Settlement cycle',
  '设备型号': 'Device model',
  '营业执照号': 'License no',
  '营业执照开始日期': 'License start date',
  '父级名称': 'Parent Name',
  '是否确认结算': 'Confirm settlement?',
  '是否确认上架': 'Confirm list?',
  '是否确认下架': 'Confirm unlist?',
  '平台抽成': 'Platform commission (%)',
  '商家简介': 'Merchant intro',
  '打款备注': 'Payment remark',
  '手续费率': 'Fee rate (%)',
  '单笔手续费封顶': 'Per-transaction fee cap',
  '单笔手续费保低': 'Per-transaction fee floor',
  '分账接收方编号': 'Split receiver no',
  '分账接收方名称': 'Split receiver name',
  '审核处理说明': 'Audit note',
  '渠道': 'Channel',
  '子商户号': 'Sub-merchant no',
  'channelId': 'Channel ID',
  'registerChannel': 'Register channel',
  'receOrgNo': 'Receiving org no',
  'resultMessage': 'Result message',
  '注册渠道': 'Register channel',
  '注册状态': 'Register status',
  '营业时间': 'Business Time',
  '商家入驻时长默认1年': 'Entry duration, default 1 year',
  '是否默认说明': 'Default: 1 yes, 0 no',
  '联系人信息': 'Contact info',
  '结算信息': 'Settlement info',
  '图片信息': 'Images',
  '其他信息': 'Other info',
  '进件POS类型': 'POS type',
  '机构代码': 'Org code',
  '营业执照照片': 'Business license photo',
  '商户联系人手机号码': 'Contact mobile',
  '银行卡': 'Bank card',
  '银行卡图片': 'Bank card image',
  '费率信息': 'Fee info',
  '收款上限': 'Collection cap',
  '收款税点区间': 'Tax point range',
  '合作协议': 'Cooperation agreement',
  '下载模板': 'Download template',
  '进件描述': 'Application memo',
  '拉卡拉内部商户号': 'Lakala internal merchant no',
  '法人身份证国徽面': 'Legal person ID (national emblem)',
  '法人身份证人像面': 'Legal person ID (portrait)',
  '法人身份证开始日期': 'Legal person ID start date',
  '法人身份证有效期': 'Legal person ID expiry',
  '商户MCC编号': 'Merchant MCC',
  '结算账户清算行号': 'Clearing bank code',
  '结算账户性质': 'Account type',
  '结算人证件号码': 'Settler ID no',
  '结算人证件有效期': 'Settler ID expiry',
  '商户门头照': 'Storefront photo',
  '商铺内部照片': 'Interior photo',
  '线下纸质协议': 'Paper agreement',
  '电子协议': 'Electronic agreement',
  '合作资质证明': 'Cooperation qualification',
  '食品经营相关资质': 'Food business license',
  '非法人结算授权书': 'Non-legal-person settlement authorization',
  '商户地区代码': 'Region code',
  '商户经营内容': 'Business scope',
  '大额理财- 手续费承担方': 'Wealth mgmt — fee bearer',
  '大额理财- 最小月交易额': 'Wealth mgmt — min monthly amount',
  '大额理财- 收取服务费': 'Wealth mgmt — service fee',
  '终端设备序列号': 'Terminal serial no',
  '终端版本号': 'Terminal version',
  '销售人员': 'Sales staff',
  '终端数量': 'Terminal qty',

  '简称': 'Short Name',
  '全称': 'Full Name',
  '上级id': 'Parent ID',
  '行政级别': 'Admin Level',
  '拉卡拉code': 'Lakala Code',
  '国家名称': 'Country Name',
  '国家英文名称': 'English Name',
  '国家区号': 'Country Code',
  '三方码': 'Three-word Code',
  '国际化语言代码': 'Language Tag',
  'mcc': 'MCC',
  '拉卡拉数据导入': 'Import Lakala Data',
  '上传中...': 'Uploading...',
  '请将文件拖拽到此处上传': 'Drag file here to upload',
  '支持单个上传，也可以点击后选择文件上传': 'Support single upload, or click to select file',
}
